"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as _Builtin from "./_Builtin/index.js";
import * as _utils from "./utils";
import _styles from "./Security.module.css";
export function Security({ as: _Component = _Builtin.Section, title = "Enterprise-grade security", text = "Keep your company's data secure and compliant with industry-leading security standards and certifications.", linktext = "Explore our Trust Center", link = {
    href: "https://monday.com/trustcenter",
    target: "_blank"
} }) {
    return /*#__PURE__*/ _jsx(_Component, {
        className: _utils.cx(_styles, "sec-security"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ _jsx(_Builtin.Block, {
            className: _utils.cx(_styles, "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ _jsx(_Builtin.Block, {
                className: _utils.cx(_styles, "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ _jsxs(_Builtin.Block, {
                    className: _utils.cx(_styles, "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ _jsx(_Builtin.Block, {
                            className: _utils.cx(_styles, "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ _jsx(_Builtin.Block, {
                                className: _utils.cx(_styles, "fw1_section-headline-parent"),
                                tag: "div",
                                children: /*#__PURE__*/ _jsx(_Builtin.Heading, {
                                    className: _utils.cx(_styles, "fw1_section-title"),
                                    tag: "h2",
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(_Builtin.Block, {
                            className: _utils.cx(_styles, "comp_hp-security"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                    className: _utils.cx(_styles, "group_security-logos"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ _jsx(_Builtin.DOM, {
                                            className: _utils.cx(_styles, "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749471604/growth-marketing/web-experience/hp-jun-25/security/logo-gdpr.png",
                                            alt: "logo GDPR"
                                        }),
                                        /*#__PURE__*/ _jsx(_Builtin.DOM, {
                                            className: _utils.cx(_styles, "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472274/growth-marketing/web-experience/hp-jun-25/security/logo-soc2-v2.png",
                                            alt: "logo soc2"
                                        }),
                                        /*#__PURE__*/ _jsx(_Builtin.DOM, {
                                            className: _utils.cx(_styles, "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472155/growth-marketing/web-experience/hp-jun-25/security/logo-iso-27001.png",
                                            alt: "logo iso"
                                        }),
                                        /*#__PURE__*/ _jsx(_Builtin.DOM, {
                                            className: _utils.cx(_styles, "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472267/growth-marketing/web-experience/hp-jun-25/security/logo-hipaa-v2.png",
                                            alt: "logo hipaa"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                    className: _utils.cx(_styles, "group_security-content"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ _jsx(_Builtin.Paragraph, {
                                            className: _utils.cx(_styles, "security-content-par"),
                                            children: text
                                        }),
                                        /*#__PURE__*/ _jsxs(_Builtin.Link, {
                                            className: _utils.cx(_styles, "m_button-link"),
                                            button: false,
                                            block: "inline",
                                            options: link,
                                            children: [
                                                /*#__PURE__*/ _jsx(_Builtin.Block, {
                                                    tag: "div",
                                                    children: linktext
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.HtmlEmbed, {
                                                    className: _utils.cx(_styles, "m_button-arrow"),
                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Block, {
                                                    className: _utils.cx(_styles, "m_link-underline"),
                                                    tag: "div"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
